import React, { useMemo } from 'react';

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@material-ui/core';
import PropTypes from 'prop-types';

import { t, number } from '~/helpers';

import { WrapperTabela } from './styles';

export default function TablePitStopControleAbastecimento({ rows }) {
  const headers = useMemo(
    () => [
      { label: t('s.relatorio.pitstop.dataencoste'), align: 'center' },
      { label: t('s.relatorio.pitstop.horaencoste'), align: 'center' },
      { label: t('s.menu.cadastro.veiculo.locomotiva'), align: 'left' },
      { label: t('s.cadastro.pitstop.trem'), align: 'left' },
      { label: t('s.menu.configuracao.bico'), align: 'right' },
      { label: t('s.global.volume'), align: 'right' },
      { label: t('s.geral.horainicial'), align: 'center' },
      { label: t('s.geral.horafinal'), align: 'center' },
      { label: t('s.geral.duracao'), align: 'center' },
      { label: t('s.geral.vazao'), align: 'right' },
      { label: t('s.relatorio.pitstop.horainicioareia'), align: 'center' },
      { label: t('s.relatorio.pitstop.horafinalareia'), align: 'center' },
      { label: t('s.relatorio.pitstop.duracaoareia'), align: 'center' },
      { label: t('s.cadastro.pitstop.agua'), align: 'center' },
      { label: t('s.cadastro.pitstop.limpeza'), align: 'center' },
      { label: t('s.relatorio.pitstop.qtdtampas'), align: 'center' },
      { label: t('s.relatorio.pitstop.direito'), align: 'center' },
      { label: t('s.relatorio.pitstop.esquerdo'), align: 'center' },
      { label: t('s.relatorio.pitstop.dataliberacao'), align: 'center' },
      { label: t('s.relatorio.pitstop.horaliberacao'), align: 'center' },
      { label: t('s.menu.operacao.pitstop'), align: 'center' },
      { label: t('s.relatorio.pitstop.abastecedor'), align: 'left' },
      { label: t('s.cadastro.pitstop.codigoatendimento'), align: 'right' },
    ],
    []
  );

  return (
    <WrapperTabela height="80vh">
      <TableContainer>
        <Table stickyHeader aria-label="sticky table" size="small">
          <TableHead>
            <TableRow>
              {headers.map((header, index) => (
                <TableCell
                  align={header.align}
                  key={'cell-index-head-' + index}
                >
                  {header.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, index) => (
              <TableRow hover tabIndex={-1} key={'table-row-body-' + index}>
                <TableCell align="center">
                  {row.dataencostecontroleabastecimento}
                </TableCell>
                <TableCell align="center">
                  {row.horaencostecontroleabastecimento}
                </TableCell>
                <TableCell>{row.idveiculo}</TableCell>
                <TableCell>{row.trematendimento}</TableCell>
                <TableCell align="right">
                  {row.idbicoabastecimento}
                </TableCell>
                <TableCell align="right">
                  {row.volumemovimentacaoabastecimento != null
                    ? number(
                        row.volumemovimentacaoabastecimento,
                        2
                      )
                    : ''}
                </TableCell>
                <TableCell align="center">
                  {row.datahorainicialmovimentacaoabastecimento}
                </TableCell>
                <TableCell align="center">
                  {row.datahorafinalmovimentacaoabastecimento}
                </TableCell>
                <TableCell align="center">
                  {row.duracaoabastecimentodieselcontroleabastecimento}
                </TableCell>
                <TableCell align="right">
                  {row.vazaoabastecimentodieselcontroleabastecimento}
                </TableCell>
                <TableCell align="center">
                  {row.datainicioatendimentoareia}
                </TableCell>
                <TableCell align="center">
                  {row.datafimatendimentoareia}
                </TableCell>
                <TableCell align="center">
                  {row.duracaoareia}
                </TableCell>
                <TableCell align="center">
                  {row.agua}
                </TableCell>
                <TableCell align="center">
                  {row.limpeza}
                </TableCell>
                <TableCell align="center">
                  {row.qtdtampascontroleabastecimento}
                </TableCell>
                <TableCell align="center">
                  {row.direitocontroleabastecimento}
                </TableCell>
                <TableCell align="center">
                  {row.esquerdocontroleabastecimento}
                </TableCell>
                <TableCell align="center">
                  {row.dataliberacaocontroleabastecimento}
                </TableCell>
                <TableCell align="center">
                  {row.horaliberacaocontroleabastecimento}
                </TableCell>
                <TableCell align="center">
                  {row.pitstopcontroleabastecimento}
                </TableCell>
                <TableCell>{row.nomeusuarioabastecimento}</TableCell>
                <TableCell align="right">
                  {row.codigoatendimento}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </WrapperTabela>
  );
}

TablePitStopControleAbastecimento.propTypes = {
  rows: PropTypes.arrayOf(PropTypes.object).isRequired,
};




